import {
    PromotedServiceAssignmentResult,
    PromotedServiceAssignmentUpdateParameters,
    useRepositoryMutation,
} from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { MewsTeam } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';
import { FormFields, FormValues, servicePromotionSchema } from '../schema';
import { getOptionsFromFormValues } from '../utils/queryUtils';

interface UpdateMutationProps {
    serviceId: string;
    promotedServiceAssignmentId?: string;
    onSuccess: (data: PromotedServiceAssignmentResult) => void;
}

export const toServicePromotionUpdateParams =
    ({ serviceId, promotedServiceAssignmentId }: { serviceId: string; promotedServiceAssignmentId: string }) =>
    (formValues: FormValues): PromotedServiceAssignmentUpdateParameters => ({
        serviceId,
        promotedServiceAssignmentId,
        options: { value: getOptionsFromFormValues(formValues.promotedServiceAssignmentOptions) },
        [FormFields.PromotedResourceCategoryId]: { value: formValues[FormFields.PromotedResourceCategoryId] },
        [FormFields.PromotedRateId]: { value: formValues[FormFields.PromotedRateId] },
        [FormFields.Enabled]: { value: formValues[FormFields.Enabled] },
        [FormFields.Ordering]: { value: formValues[FormFields.Ordering] },
        // @ts-expect-error @TSFixMeError: Type of computed property's value is '{ value: PromotedServiceAssignmentUnitCountLimit; }', which is not assignable to type 'PromotedServiceAssignmentUnitCountLimit | null | undefined'
        [FormFields.UnitCountLimit]: { value: formValues[FormFields.UnitCountLimit] },
        // @ts-expect-error @TSFixMeError: Type of computed property's value is '{ value: PromotedServiceAssignmentReservationIntervalLimit; }', which is not assignable to type 'PromotedServiceAssignmentReservationIntervalLimit | null | undefined'.
        [FormFields.ReservationIntervalLimit]: { value: formValues[FormFields.ReservationIntervalLimit] },
    });

export const useUpdateServicePromotionMutation = ({
    serviceId,
    promotedServiceAssignmentId,
    onSuccess,
}: UpdateMutationProps) =>
    useRepositoryMutation('promotedServiceAssignments', 'update', {
        ...(promotedServiceAssignmentId && {
            transformParams: (formValues: FormValues) =>
                servicePromotionSchema
                    .transform(toServicePromotionUpdateParams({ serviceId, promotedServiceAssignmentId }))
                    .parse(formValues),
        }),
        invalidateQueries: {
            promotedServiceAssignments: ['getAll'],
        },
        onSuccess: (data) => {
            showSuccessAlert({
                description: lt(TextKey.PromotedServiceAssignmentUpdateSuccessMessage),
                action: { text: lt(TextKey.ViewDetails), onClick: () => onSuccess(data) },
                id: data.promotedServiceAssignments[0].id,
            });
        },
        meta: {
            logError: {
                team: MewsTeam.Spacetime,
            },
        },
    });
